/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Pointer = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 14 20">
      <path
        d="M0.49875 0.0956163C0.8025 -0.0581337 1.17 -0.0243836 1.44 0.181866L13.44 9.17812C13.7513 9.41062 13.875 9.81562 13.755 10.1831C13.635 10.5506 13.29 10.7981 12.9 10.7981H7.18875L10.5225 17.4619C10.8188 18.0544 10.5787 18.7744 9.98625 19.0706C9.39375 19.3669 8.67375 19.1269 8.3775 18.5344L5.04375 11.8706L1.62 16.4381C1.3875 16.7494 0.9825 16.8731 0.615 16.7531C0.2475 16.6331 0 16.2881 0 15.9019V0.901866C0 0.560616 0.19125 0.249366 0.49875 0.0956163Z"
        fill="#000"
      />
    </BaseSvgIcon>
  )
}

export default Pointer
